export default __webpack_public_path__ + "static/vr-1bd1d11e89d3b579cf468c9c926a07c0.jpg";